import "./RowsLimit.scss";
import RowsLimit from "./RowsLimit";

export { RowsLimit };
